import { useEffect } from "react";
import Dialog from "../dialog/dialog.index";
import { get, responseValidator } from "../../../scripts/api";
import API from "../../../urls/api";

export interface LockExcelDialogProps {
    userName: string | undefined;
    open: boolean;
    closeHandler: () => void;
    version_group: string;
    navigatingToPath: () => void;
}

export function LockExcelDialog(props: LockExcelDialogProps) {
    const { userName, open, closeHandler, version_group, navigatingToPath } = props;

    useEffect(() => {
        if (version_group && open) {
            const modalIntervalId = setInterval(() => {
                get((data, status) => {
                    if (responseValidator(status)) navigatingToPath();
                }, API.fileManager.checkExcelStatus(version_group));
            }, 30000);
            return () => {
                clearInterval(modalIntervalId);
            };
        }
    }, [version_group, open]);

    return (
        <Dialog status={open} onClose={closeHandler} title="توجه" closeOnBlur={true} className="relative">
            <div className="px-6 pt-4 pb-6 text-secondary-800 font-medium leading-8 text-base">
                <div> {userName ?? `کاربر`} عزیز,</div>
                <div>فایل توسط کاربر دیگری در حال ویرایش است، لطفاً چند دقیقه دیگر مجدداً امتحان کنید.</div>
            </div>
            <div className="absolute bottom-0 h-1.5 w-full md:w-[97%] m-auto left-0 right-0 md:rounded-b-[20px] overflow-hidden">
                <div className="progress w-full h-full md:rounded-[20px] bg-primary-500 left-right" />
            </div>
        </Dialog>
    );
}
